/**
 * KAN-870: версия текущей сборки и сравнение с версией на сервере.
 * __APP_VERSION__ подставляет vite (define); без него (vitest, dev) версия 'dev',
 * и для неё обновление не показывается никогда.
 */
export const DEV_VERSION = 'dev';

export const APP_VERSION: string =
  typeof __APP_VERSION__ !== 'undefined' && __APP_VERSION__ ? __APP_VERSION__ : DEV_VERSION;

/** true, если сервер отдал версию, отличную от текущей сборки. */
export function isNewVersion(current: string, remote: string | null | undefined): boolean {
  const cur = (current ?? '').trim();
  const next = (remote ?? '').trim();
  if (!cur || cur === DEV_VERSION || !next) return false;
  return cur !== next;
}
